










































































































import Vue from "vue";
import { mapGetters } from "vuex";
import moment from "moment";

import { GetReportSubscriptionCommand } from "@/model/communication/reportSubscription/GetReportSubscriptionCommand";
import { SetReportSubscriptionsCommand } from "@/model/communication/reportSubscription/SetReportSubscriptionsCommand";

import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";
import { ReportSubscription, ReportSubscriptionOptions } from "@/model/data/reportSubscription/ReportSubscription";
import { ReportSubscriptionTypeEnum, getSubscriptionTypeLabel, getSubscriptionRequiredPrivileges } from "@/model/data/reportSubscription/ReportSubscriptionTypeEnum";
import { getMultiDaysOfWeekString } from "@/model/data/reportSubscription/DayOfWeekEnum";

import { SendReportNowCommand } from "@/model/communication/reportSubscription/SendReportNowCommand";

import DaysOfWeekToggler from "@/components/DaysOfWeekToggler.vue";
import { ReportSubscriptionChannelEnum, getReportSubscriptionChannelEnumLabel } from "@/model/data/reportSubscription/ReportSubscriptionChannelEnum";

class ReportSubscriptionUI extends ReportSubscription {
    enabled: boolean = false;
}

export default Vue.extend({
    components: { DaysOfWeekToggler },
    data() {
        return {
            ReportSubscriptionChannelEnum,
            ReportSubscriptionTypeEnum,
            loading: false,
            reportSubscriptions: [],
            sendNowLoading: [],
            sendReportNowDisabled: false,
        };
    },
    computed: {
        ...mapGetters(["authUserHasPrivilege"]),

        userTimeFormat() {
            return this.$store.getters.userTimeFormat;
        },

        authUserHasPrivilege() {
            return this.$store.getters.authUserHasPrivilege;
        },

        availableReportSubscriptions(): ReportSubscriptionUI[] {
            let res = [];
            Object.keys(ReportSubscriptionChannelEnum)
                .filter((v) => !isNaN(Number(v)) && (v as unknown as ReportSubscriptionChannelEnum) != ReportSubscriptionChannelEnum.Unknown)
                .forEach((channel) => {
                    Object.keys(ReportSubscriptionTypeEnum)
                        .filter((v) => !isNaN(Number(v)))
                        .forEach((reportType) => {
                            if (this.authUserHasPrivilege(getSubscriptionRequiredPrivileges(reportType))) {
                                let rsUI = new ReportSubscriptionUI();
                                if ((reportType as unknown as ReportSubscriptionTypeEnum) == ReportSubscriptionTypeEnum.LastDayTransactionsReport) {
                                    rsUI.options = new ReportSubscriptionOptions();
                                    rsUI.options.startTime = "00:00";
                                    rsUI.options.endTime = "23:59";
                                }
                                rsUI.reportSubscriptionType = reportType as unknown as ReportSubscriptionTypeEnum;
                                rsUI.channel = channel as unknown as ReportSubscriptionChannelEnum;
                                res.push(rsUI);
                            }
                        });
                });
            return res;
        },

        canSave(): boolean {
            if (!(this.reportSubscriptions as ReportSubscriptionUI[]).some((c) => c.enabled && c.reportSubscriptionType == ReportSubscriptionTypeEnum.LastDayTransactionsReport))
                return true;
            else {
                var rs_transactions = (this.reportSubscriptions as ReportSubscriptionUI[]).find(
                    (c) => c.enabled && c.reportSubscriptionType == ReportSubscriptionTypeEnum.LastDayTransactionsReport
                );
                if (this.timeValidation(rs_transactions.options.startTime) == true && this.timeValidation(rs_transactions.options.endTime) == true) return true;
                else return false;
            }
        },
    },
    methods: {
        getMultiDaysOfWeekString,
        getSubscriptionTypeLabel,
        getReportSubscriptionChannelEnumLabel,
        formatTime(time) {
            return moment(time, "HH:mm").format(this.userTimeFormat.timeFormat);
        },

        timeValidation(value) {
            // Utilizza un'espressione regolare per controllare il formato dell'orario
            const timeRegex = /^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/;

            if (!timeRegex.test(value)) {
                return "HH:mm";
            }
            return true; // La validazione ha successo
        },

        setCurrentReportSubscriptions(reportSubscriptionsFromServer: ReportSubscription[]) {
            this.reportSubscriptions = [];
            reportSubscriptionsFromServer.forEach((rsFromServer) => {
                var sub = (this.availableReportSubscriptions as ReportSubscriptionUI[]).find(
                    (rs) => rs.reportSubscriptionType == rsFromServer.reportSubscriptionType && rs.channel == rsFromServer.channel
                );
                if (sub != undefined) {
                    sub.clientUserName = rsFromServer.clientUserName;
                    if (rsFromServer.options != null) sub.options = rsFromServer.options;
                    sub.time = moment.utc(rsFromServer.time, "HH:mm").local().format("HH:mm");
                    sub.days = rsFromServer.days;
                    sub.params = rsFromServer.params;
                    sub.enabled = true;
                }
            });

            this.reportSubscriptions = this.availableReportSubscriptions;
        },
        async getReportSubscriptions() {
            this.loading = true;

            let res = await new GetReportSubscriptionCommand().execute();

            if (res.responseStatus == ApiResponseStatusEnum.Success) {
                this.setCurrentReportSubscriptions(res.reportSubscriptions);
            }

            this.loading = false;
        },
        async save() {
            this.loading = true;

            let reportsToSave = (this.reportSubscriptions as ReportSubscriptionUI[]).filter((c) => c.enabled);
            if (reportsToSave.findIndex((r) => r.reportSubscriptionType == ReportSubscriptionTypeEnum.PlatformMaintenanceReport) > -1) {
                let platformMaintenanceRs = reportsToSave[reportsToSave.findIndex((r) => r.reportSubscriptionType == ReportSubscriptionTypeEnum.PlatformMaintenanceReport)];
                platformMaintenanceRs.days = 1;
                platformMaintenanceRs.time = moment().format("HH:mm");
                platformMaintenanceRs.channel = ReportSubscriptionChannelEnum.Email;
            }
            if (reportsToSave && reportsToSave.length) {
                reportsToSave.forEach((report) => {
                    report.time = moment(report.time, "HH:mm").utc().format("HH:mm");
                });
            }
            let res = await new SetReportSubscriptionsCommand(reportsToSave).execute();
            if (res.responseStatus == ApiResponseStatusEnum.Success) {
                this.setCurrentReportSubscriptions(res.reportSubscriptions);
            }

            this.loading = false;
        },
        async sendReportNow(rs: ReportSubscription, id: number) {
            this.sendNowLoading.push(id);
            this.sendReportNowDisabled = true;

            await new SendReportNowCommand(rs).execute();

            setTimeout(() => {
                this.sendReportNowDisabled = false;
                this.sendNowLoading = [];
            }, 5000);
        },

        timeEnabled(sub) {
            let type = parseInt(sub.reportSubscriptionType) as ReportSubscriptionTypeEnum;
            return type != ReportSubscriptionTypeEnum.PlatformMaintenanceReport;
        },
    },
    created() {
        this.getReportSubscriptions();
    },
});
